import classes from 'components/common/Tables/Cells/RiskScoreCell/RiskScoreCell.module.scss';

export const RiskScoreCell = ({ value }: { value: number }) => {
    const colorClass = value <= 1 ? 'green' : value < 1.25 ? 'red' : 'orange';
    return <div className={`${classes.riskScoreCell} ${classes[colorClass]}`}>{value}</div>;
};
